/* eslint-disable import/prefer-default-export */
import React from 'react';

import Placeholder from '../Placeholder';

export const LinkPlaceholder = ({ style }) => (
  <Placeholder width="200px" height="26px" colour="#000" style={style} />
);
